module.exports = __webpack_public_path__ + "static/img/loading.08e699c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.png
// module id = SnTU
// module chunks = 14